export const MAX_WIDTH = 1920

export const uploadOptions = { compression: { maxWidth: MAX_WIDTH } }
